import React, { useState } from "react"
import Plus from "../assets/icons/umr/plus.svg"
import Minus from "../assets/icons/umr/minus.svg"

interface Foldable {
  heading: JSX.Element
  details: JSX.Element
}

const Foldable: React.FC<Foldable> = ({ heading, details }) => {
  const [open, setOpenState] = useState(false)
  return (
      <div class="flex items-start" >
          <span class="fill-current text-fb12-red-500 cursor-pointer" onClick={() => setOpenState(!open)}>
              <div class="mr-3 py-2">
                  {open ? <Minus class="h-6" /> : <Plus class="h-6" />}
              </div>
          </span>
          <div>
              {heading}

              {open ? details : ""}
          </div>
      </div>
  )
}

export default Foldable
